import apiClient, { resolveFileUrl } from "../api/client";

// Fetches the brochure document record from the API, then triggers a real
// file download of the current brochure PDF.
const downLoadBrousher = async () => {
  try {
    const { data } = await apiClient.get("/documents/brochure");
    if (!data?.fileUrl) {
      console.warn("Brochure not available yet.");
      return;
    }

    const fileUrl = resolveFileUrl(data.fileUrl);
    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = data.originalName || "brochure.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Failed to download brochure", err);
  }
};

export default downLoadBrousher;
